import { useContext } from "react";
import { HelpDeskContext } from "../context";

export const useHelpDesk = () => useContext(HelpDeskContext);
